import base64Decoder from 'app/shared/decoders/base64Decoder';

// Decodes an event's base64 input payload to a plain object, or null when it is absent or
// undecodable. Shared by collectPayloadPaths (autocomplete hints) and filterEventsByPayload
// (client-side filtering), so both read the input event the same way.
//
// Memoized per event object: the client-side filter re-runs on every keystroke and decoding is
// pure for a given (immutable) event, so we decode each event at most once. This also means a
// malformed payload reports to Sentry once (inside base64Decoder), not once per keystroke.
const decodedByEvent = new WeakMap();

export default function decodeInputEvent(event) {
  if (!event || !event.inputEvent) {
    return null;
  }

  if (decodedByEvent.has(event)) {
    return decodedByEvent.get(event);
  }

  let decoded;
  try {
    decoded = JSON.parse(base64Decoder(event.inputEvent));
  } catch {
    decoded = null;
  }

  decodedByEvent.set(event, decoded);
  return decoded;
}
